import { render, staticRenderFns } from "./Influencers.vue?vue&type=template&id=4079d8c8&scoped=true&"
import script from "./Influencers.vue?vue&type=script&lang=js&"
export * from "./Influencers.vue?vue&type=script&lang=js&"
import style0 from "./Influencers.vue?vue&type=style&index=0&id=4079d8c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4079d8c8",
  null
  
)

export default component.exports